import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { DurationUnitEnum } from '../../../shared/enums/duration-unit.enum';
import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { AssetTypeEnum } from '../../assets/enums/asset-type.enum';

/**
 * Asset discovery filters
 */
export class AssetDiscoveryCacheFilters extends ApiRequestFilters {
  /**
   * Area UUID
   */
  areaUuid?: string;

  /**
   * Types
   */
  types?: AssetTypeEnum[];

	/**
	 * Vehicle group UUID filters
	 */
	vehicleGroupUuids?: string[];

	/**
	 * Duration unit
	 */
	durationUnit?: DurationUnitEnum;

  /**
   * Duration
   */
  @TransformInt()
  duration?: number;

  /**
   * Flag to include unavailable records in results
   */
  includeUnavailable?: boolean = true;
}
